export default __webpack_public_path__ + "static/media/Inconsolata-Regular.ed7f6e5b.ttf";